module.exports = __webpack_public_path__ + "static/media/oxygen_saturation.7fc66978.svg";